import { ClockIcon } from "../../AscIcons";
import AscSelectInput from "../AscSelectInput/AscSelectInput";
import { AscTimeOptions, DEFAULT_TIME_RANGES } from "./DefaultTimeOptions";
import styles from "./AscTimeInput.module.scss";
import { AscSelectInputSingleProps } from "../AscSelectInput/AscSelectInput.types";
import { useCallback } from "react";

export interface AscTimeInputProps
  extends Omit<
  AscSelectInputSingleProps<AscTimeOptions["value"]>,
    "multiple" | "onChange"
  > {
  timeOptions?: AscTimeOptions[];
  defaultValue?: AscTimeOptions["value"];
  onChange?: (value: AscTimeOptions["value"] | undefined) => void;
    /**
   * This is used to set the value of the field in the formik form.
   */
    setFieldValue?: (name: string, time?: AscTimeOptions["value"]) => void;
}

function AscTimeInput({
  timeOptions = DEFAULT_TIME_RANGES,
  onChange,
  defaultValue,
  setFieldValue,
  ...rest
}: AscTimeInputProps) {

  const handleChange = useCallback((value?:AscTimeOptions["value"])=>{
    onChange?.(value);

    if (rest?.name) {
       setFieldValue?.(rest?.name, value);
    }
},[rest?.name])
  
  return (
    <AscSelectInput<AscTimeOptions["value"]>
      optionContainerClassName={styles.optionsContainer}
      optionClassName={styles.option}
      selectedOptionClassName={styles.selectedOption}
      disabledOptionClassName={styles.disabledOption}
      icon={<ClockIcon />}
      defaultValue={defaultValue}
      onChange={handleChange}
      multiple={false}
      placeholder="Select a time"
      {...rest}
    >
      {timeOptions?.map((option) => (
        <AscSelectInput.Option
          key={option.value}
          value={option.value}
          label={option.label}
          disabled={option.disabled}
        />
      ))}
    </AscSelectInput>
  );
}

export default AscTimeInput;
